/**
 * Page Header Component
 * 
 * Shared header for pricing and member-credits pages
 * Matches dashboard header design
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { KnodsIconLogo } from './ui/KnodsIconLogo';
import { UserMenu } from './UserMenu';
import './PageHeader.css';

interface PageHeaderProps {
  showCreateButton?: boolean;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ showCreateButton = false }) => {
  const navigate = useNavigate();

  return (
    <header className="page-header">
      <div className="page-header-left">
        <button 
          className="page-header-logo-btn"
          onClick={() => navigate('/')}
          aria-label="Go to dashboard"
        >
          <KnodsIconLogo className="page-header-logo" />
        </button>
      </div>
      <div className="page-header-right">
        <UserMenu creditsTooltipMode="buy-only" />
        {showCreateButton && (
          <button 
            className="page-header-create-button" 
            onClick={() => navigate('/flow')}
          >
            Create New Knod
          </button>
        )}
      </div>
    </header>
  );
};

export default PageHeader;
